import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import CustomDataGrid from "../../CustomDataGrid";
import { Box, Avatar, Grid, Tooltip, IconButton } from "@mui/material";
import { alignPropType } from "react-bootstrap/esm/types";
import SearchIcon from "@mui/icons-material/Search";
import Odontogram from "../../Odontogram";
import FacebookCircularProgress from "../../FacebookCircularProgress";

const OdontogramasTab = ({ rowsPadre, rowsHijo }) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [itemsFichado, setItemsFichado] = useState([]);
  const [odontogramaRows, setOdontoGramaRows] = useState([]);
  const [showFichado, setShowFichado] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleShowOdontograma = (row) => {
    console.log("Selected Row:", row); // Verifica si row tiene el valor correcto
    setSelectedRow(row); // Se actualiza el estado
  };
  useEffect(() => {
    if (selectedRow) {
      setLoading(true); // Inicia el estado de carga
      setShowFichado(false); // Muestra el odontograma
      console.log("Selected Row actualizado:", selectedRow); // Verifica el valor actualizado

      // Establece un temporizador para hacer una pausa
      const timer = setTimeout(() => {
        const items = rowsHijo.filter(
          (item) => item.fichado_id === selectedRow.id
        );
        console.log("Filtered Items:", items);
        setItemsFichado(items); // Actualiza los ítems filtrados después de la pausa
        setLoading(false); // Finaliza el estado de carga después de la pausa
        setShowFichado(true);
      }, 500); // Pausa de 2 segundos (2000 ms)

      // Limpiar el temporizador si el componente se desmonta o si selectedRow cambia antes de que el temporizador termine
      return () => clearTimeout(timer);
    } else {
      if (rowsPadre.length > 0) {
        const sortedRows = [...rowsPadre].sort((a, b) => {
          const dateA = new Date(a.fecha_emision); // Convierte fecha_emision a fecha
          const dateB = new Date(b.fecha_emision);
          return dateB - dateA; // Ordena en orden descendente (más reciente primero)
        });
        const firstRow = sortedRows[0];
        setSelectedRow(firstRow);
      }
    }
  }, [selectedRow, rowsHijo]); // Esto se ejecuta cuando `selectedRow` o `rowsHijo` cambia

  let odontogramState = {};

  const handleToothUpdate = (id, toothState) => {
    odontogramState[id] = toothState;
  };

  const handleOdontogramaRow = (row) => {
    setOdontoGramaRows(...odontogramaRows.push(row));
  };

  const columnsObject = [
    { field: "fecha_arg", headerName: "Fecha", flex: 0.5, align: "left" },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      flex: 1,
      textTransform: "capitalize",
      align: "left",
    },
    {
      field: "actions",
      headerName: "Ver",
      flex: 0.5,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <IconButton
          color="primary"
          size="small"
          onClick={() => handleShowOdontograma(params.row)}
        >
          <SearchIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];
  console.log("Rows Padre:", selectedRow?.length);
  console.log("Rows Hijo:", itemsFichado?.length);
  return (
    <Grid container spacing={2}>
      {/* Left: Table in 4 columns */}
      <Grid item xs={12} sm={4}>
        <CustomDataGrid
          columnsObject={columnsObject}
          dataRows={rowsPadre}
          sortField="fecha_emision"
          sortOrder="desc"
        />
      </Grid>

      {/* Right: Image in 8 columns */}
      <Grid item xs={12} sm={8}>
        {loading && (
          <div className="flex justify-center mt-10">
            <FacebookCircularProgress />
          </div>
        )}
        {selectedRow && itemsFichado?.length > 0 && showFichado && !loading && (
          <>
            <Typography
              variant="body1"
              sx={{ ml: 4, textTransform: "capitalize" }}
            >
              Odontólogo: {selectedRow?.odontologo.toLowerCase()}
              &nbsp;&nbsp;&nbsp;Fecha: {selectedRow?.fecha_arg}
            </Typography>

            <Box
              sx={{
                width: "100%", // Asegura que el contenedor ocupe el 100% del ancho disponible
                maxWidth: "100%", // Asegura que el ancho no se exceda
                height: "500px", // Establece una altura fija para el contenedor
                overflowX: "auto", // Permite el desplazamiento horizontal si el contenido se desborda
                overflowY: "hidden", // Evita el desbordamiento vertical
                display: "flex", // Flexbox para centrar el contenido
                justifyContent: "center", // Centra el contenido horizontalmente
                alignItems: "center", // Centra el contenido verticalmente
                marginTop: 2,
                marginLeft: 10,
              }}
            >
              <Odontogram
                data={itemsFichado}
                tratamiento={null}
                color={null}
                readonly={true}
                handleToothUpdate={handleToothUpdate}
                handleOdontogramaRow={handleOdontogramaRow}
                cleanodontograma={false}
              />
            </Box>
          </>
        )}
        {selectedRow?.sin_patologia === 1 && itemsFichado?.length === 0 && (
          <Typography
            variant="h4"
            sx={{ ml: -12, mt: -3, color: "primary.main" }}
          >
            Sin Patología
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default OdontogramasTab;
